<template>
    <div class="aside" v-if="chatroomInfo">        
        <div class="list-wrapper">
          <ul>
            <li class="item " id="room-info">
             
              <div class="subMenu">
                <div class="user-list">
                    <div class="bd">
                        <div class="bd-tab" @click="managerViewToggle">방장 및 매니저</div>
                        <!--방장-->
                        <div class="owner" v-if="managerView">                            
                            <chat-message
                                :userinfo="chatroomInfo.user"
                                :displaymytalk="false"
                                :displayProfileImage="false"
                                :lineheight="true"  
                                :userList="true"   
                                :roominfo ="chatroomInfo" 
                                :owner="isOwner"
                                :manager="isManager"         
                                @view-user-info ="viewUserInfo"                                            
                            />      
                        </div>
                        <!-- 매니져 -->
                        <div v-if="chatroomInfo.manager.length > 0 && managerView" >
                            <template v-for="(manager, index) in chatroomInfo.manager" :key="index">
                                <div class="manager">
                                <!-- <user-name-tag
                                :user="manager.user"
                                :displaymytalk="false"
                                :displayProfileImage="true"
                                :roominfo ="chatroomInfo"
                                :manager="true"
                                :managerInfo="chatroomInfo.manager"
                                /> -->
                                 <chat-message
                                :userinfo="manager.user"
                                :displaymytalk="false"
                                :displayProfileImage="false"
                                :lineheight="true"  
                                :userList="true"   
                                :roominfo ="chatroomInfo"  
                                :owner="isOwner"
                                :manager="isManager"   
                                @view-user-info ="viewUserInfo"                                                                                          
                                />    
                                </div>
                            </template>
                        </div>
                    </div>
                    
                    <!--방장 및 매니져 메뉴 -->
                    <div class="room_control" v-if="isOwner || isManager || user.role==='admin'">
                      <div class="title">관리메뉴</div>
                      <ul>
                        <li @click="ChatClear()">채팅 지우기</li>
                      </ul>                     
                    </div>
                   
                    <!--방장만 보여줌-->
                    <div class="bd" v-if="chatroomInfo.ban.length > 0 && isOwner">
                        <div class="bd-tab ban-tab" @click="banUserToggle">강퇴유저</div>                       
                        <div v-if="banUserView" class="ban_list">
                            <template v-for="(banuser, index) in chatroomInfo.ban" :key="index">
                                <div class="ban_user">
                                    <!-- <user-name-tag
                                    :user="banuser.user"
                                    :displaymytalk="false"
                                    :displayProfileImage="true"
                                    :roominfo ="chatroomInfo"                                  
                                    /> -->
                                    <chat-message
                                        :userinfo="banuser.user"
                                        :displaymytalk="false"
                                        :displayProfileImage="false"
                                        :lineheight="true"  
                                        :userList="true"   
                                        :roominfo ="chatroomInfo"  
                                        :owner="isOwner"
                                        :manager="isManager"  
                                        @view-user-info ="viewUserInfo"                                        
                                    />  
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
              </div>
            </li>

            <li class="item active" id="user-list">
              <a href="javascript:void(0)" class="btn" @click="arrowtg('user-list')">
                <div class="top" >
                  <div class="title">참여자목록</div>                 
                </div>
              </a>             
              <div class="subMenu">               
                <div class="connect-list">
                    <template v-for="(user, index) in connectusers" :key="index">
                        <!-- <user-name-tag
                        :user="user"
                        :displaymytalk="false"
                        :displayProfileImage="true"
                        :roominfo ="chatroomInfo"
                        :managerInfo="chatroomInfo.manager"                        
                        /> -->
                        <div class="user_block">                           
                            <chat-message
                                :userinfo="user"
                                :displaymytalk="false"
                                :displayProfileImage="false"
                                :lineheight="true"  
                                :userList="true"   
                                :roominfo ="chatroomInfo"  
                                :owner="isOwner"
                                :manager="isManager"  
                                @view-user-info ="viewUserInfo"                                        
                            />  
                        </div>
                         
                    </template>
                </div>

              </div>
             
            </li>                
          </ul>
        </div>       
    </div>  

    <pop-slide-up :show="userInfo.show">
        <user-info  :data="userInfo" @close-user-info="closeUserInfo" @mtm-chat-join="mtmChatJoin"/>
    </pop-slide-up>  
    <pop-mtm-chat :show="mtm_chat && user.id !==0" @close="close_mtm_chat" :chat_roomId="mtm_room_id"/>


</template>
<script>
import io from "socket.io-client";
import { removeClass } from '@/utils/selector.js';
import { auth } from '@/components/mixins/auth.js';
import ChatMessage from '@/mobile/components/chat/parts/ChatMessage'
import { chatmtm } from '@/components/mixins/chat/chatmtm.js'; //popslideup, userinfo, popmtmchat 한곳에서 불러옴
//import PopMtmChat from '@/mobile/components/ui/PopMtmChat'
export default {
    name:'',
    props:{
        chatroomInfo:{},
        room_id:{},
        connectusers:{}
    },
    data(){
        return{
            nowview:{
                state:'userlist',
                userlist:true,
                roominfo:false,
                friendlist:false
            },
            managerView:true,
            banUserView:true,          
            socket: io(this.$store.state.serverDomain + ":3000"),
            userInfo:{show:false},
           // mtm_chat:false,
            //mtm_room_id:'' 
        }
    },
    mixins:[
        auth,chatmtm
    ],
    components:{
        ChatMessage,
    },
    created() {       
        this.currentuser = this.$store.getters.currentUser;
    },
    mounted() {
    },
    methods:{       
        ChatClear(){
            //채팅내용 지우기, 방장과 매니저만 사용
            if(confirm('현재방의 채팅내용을 초기화 하시겠습니까?'))
            {
                let request = '방장';
                if(this.isManager){request ='매니저';}
                if(this.user.role==='admin'){request ='관리자';}
                let params = {
                    room_id:'room_' + this.chatroomInfo.id,
                    who: request
                }
                this.socket.emit("DeleteMessage", params, function (callback) {
                    console.log(callback);
                });
            }
          
        },      
        
        managerViewToggle(){
            this.managerView = !this.managerView
        },
        banUserToggle(){
            this.banUserView = !this.banUserView
        },
        arrowtg(now){
            console.log(now)
            //document.querySelectorAll('[data-icon="angle-up"]').remove()//.classList.add('hide');

            if(this.nowview.state !== now)
            {
                this.nowview.userlist = false;
                this.nowview.roominfo = false;
                this.nowview.friendlist = false;

                if(now ==="user-list") this.nowview.userlist = true;
                if(now ==="room-info") this.nowview.roominfo = true;
                if(now ==="friend-list") this.nowview.friendlist = true;

                this.nowview.state = now;
                removeClass('.item','active');
                let element = document.querySelector('#'+now);
                element.classList.add('active');

            }
        },       
    },
    computed:{
        isOwner()
        {
            if(this.chatroomInfo){
                return this.currentuser.id === this.chatroomInfo.user_id;
            }else{
                return false;
            }        
        },
        isManager(){
            if(this.chatroomInfo && this.chatroomInfo.manager.find((manager)=>manager.user_id === this.currentuser.id))
            {
                return true;
            }else{
                return false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.aside{  
    height: calc( 100vh - 84px);     
    .cnt span{
        background:#ee1212;
        border-radius:6px;
        color:#fff;
        font-size:11px;
        padding:2px 5px 2px 5px;
    }  
    .list-wrapper > ul{
        height: calc( 100vh - 84px);        
    } 
    .list-wrapper{     
        .item:target a{
            color:#000;
            font-weight:700;
        }
        .item a{
            text-decoration:none;
            color: #ccc;
        }               
        .item{
            max-height: 50%;
            overflow-y: auto;
            .subMenu{                 
                     
                .room_control{
                    margin-top:5px;
                    padding:3px 10px;                   
                    .title{
                        font-weight: bold;
                        border-bottom:1px solid  #f2f2f2; 
                        background: #d6ebff;
                        padding:2px 0;
                        text-align: center;
                        border-radius: 10px;
                    }    
                    ul{
                        
                        padding-top:5px;
                        li{
                            cursor: pointer;
                            padding:10px 5px;
                        }
                        li:hover{
                            background: #eee;
                        }

                    }            
                }
                .bd{                   
                    .bd-tab{
                        border-top:1px solid rgb(241, 241, 241); 
                        font-weight:bold;
                        height: 40px ;
                        font-size:14px;
                        font-family: nanumgothic;        
                        padding:10px 5px;
                        cursor:pointer;  
                        color:#1584eb;      
                               
                    }
                    .bd-tab:hover{
                        background:#f2f2f2;
                    }
                    .ban-tab{    
                        border-top:1px solid rgb(241, 241, 241);                    
                        color:#eb154e;
                        font-family: nanumgothic;
                        font-size:14px;
                        font-weight:bold;
                        height: 40px ;
                        
                    }
                    .ban_list{
                        .ban_user{
                            padding: 5px 0;
                        }                        
                    }
                    .owner{
                        background:snow;  
                        border-bottom: 1px solid #f2f2f2;    
                        padding:10px 0;         
                    }
                    .manager{
                        background:#fafdff;   
                        border-bottom: 1px solid #f2f2f2;  
                        padding:10px 0;             
                    }
                    
                }
                .connect-list{                                    
                    .user_block{
                        margin-bottom:10px;
                    }
                }
            }
            
           
            .top{                             
                line-height:40px;
                display:flex;
                padding:5px;
                .title{    
                    border-top:1px solid rgb(241, 241, 241);               
                    font-size:14px;
                    font-family: nanumgothic;                    
                    flex:1 1 auto;
                    color:#000;
                    font-weight: bold;
                }
                .cnt{
                    flex-basis: 15px;
                }
                .arrow{
                    flex-basis: 30px;
                    padding-left:5px;
                }
            }
        }
        
    }
}

</style>